import { IVaultDeposit, Vault } from '@/types'

export const MOCK_VAULT_DETAIL = {
  id: 71,
  depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
  sessionId: '0x86b7fb97085e1d1201d27e428b65b98c5fdc06ab1a510658cc079077d2e4c4d7',
  tradeId: null,
  fromTokenId: 'ETH',
  amountIn: '5000000000000000',
  fromUserAddress: '0x53bebc978f5afc70ac3bffad7bbd88a351123723',
  depositVault: '0x8827171FcB8739a8E5efCe10b42004Cb96c269b5',
  depositTx: '0x3db51fb77c88db96c52ceaedfec9f449d017d60deca560610a39d63edfde89e6',
  userEphemeralAssetChainPubkey: '0x037cba2ad7684e15946bf6f832c6b1dbb3dfba3a13cc3878f490037e69d495b5be',
  userEphemeralL2Address: '0xdDde1A55C519759b9F5eF9118db16ab870FCC552',
  mpcAssetChainPubkey: '0x02eae3777c73b531b37ac4abf3f66df5f9e32612ced513fe6db93c6d3d8a4f8686',
  userRefundPubkey: '0x53beBc978F5AfC70aC3bFfaD7bbD88A351123723',
  scriptTimeout: 1748100307,
  refundPresign: {
    presigns: [],
    refundAddress: '0x53beBc978F5AfC70aC3bFfaD7bbD88A351123723',
  },
  status: 'REFUNDED',
  processedAt: null,
  createdAt: '2025-05-23T11:25:09.183Z',
  updatedAt: '2025-05-24T15:26:27.012Z',
  events: [
    {
      tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
      action: 'ConfirmRefund',
      txId: '0x893c1cddb4db9367cc94fca00504f8ff119e99e785c6edebd312801546155b5e',
      blockNumber: 5457943,
      timestamp: 1748100422,
      inputData: {
        to: '0x5008a47004b1cACD0Fd7CE689973F6b0CB345802',
        mpc: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        from: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
        signature:
          '0xc8e3897393894087f819c50bc2babc85f6d9fefc74906c69b30e6209580a33e97c9ba14035ddb695fa6a5b72d4a323de22775a27aaf4adc77bc6c5814c9cfa641b',
        refundTxId: '0xb2b6f4b8d204ccad4db1f2ce36b985d2ad28df85c3d066ab6b2a48f81500d5a3',
        transactionHash: '0x893c1cddb4db9367cc94fca00504f8ff119e99e785c6edebd312801546155b5e',
      },
      createdAt: '2025-05-24T15:27:07.014Z',
      updatedAt: '2025-05-24T15:27:07.014Z',
      depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
    },
    {
      tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
      action: 'Refund',
      txId: '0xb2b6f4b8d204ccad4db1f2ce36b985d2ad28df85c3d066ab6b2a48f81500d5a3',
      blockNumber: 5457925,
      timestamp: 1748100386,
      inputData: {
        txId: '0xb2b6f4b8d204ccad4db1f2ce36b985d2ad28df85c3d066ab6b2a48f81500d5a3',
        timestamp: 1748100386,
      },
      createdAt: '2025-05-24T15:26:26.916Z',
      updatedAt: '2025-05-24T15:26:26.916Z',
      depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
    },
    {
      tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
      action: 'ReportFailure',
      txId: '0x4cac45bf51eeb241a093f4537fdcf3f56912822c429b77061af36bc8c49b44fe',
      blockNumber: 5457903,
      timestamp: 1748100342,
      inputData: {
        to: '0x5008a47004b1cACD0Fd7CE689973F6b0CB345802',
        mpc: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        from: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
        msgError: 'Trade expired',
        signature: '0x',
        transactionHash: '0x4cac45bf51eeb241a093f4537fdcf3f56912822c429b77061af36bc8c49b44fe',
      },
      createdAt: '2025-05-24T15:25:46.949Z',
      updatedAt: '2025-05-24T15:25:46.949Z',
      depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
    },
    {
      tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
      action: 'ConfirmDeposit',
      txId: '0xd32c58f4395da71e934cc801892f03db611ef1c4c5c5bf474a0d1b40c2f1ccd7',
      blockNumber: 5407535,
      timestamp: 1747999606,
      inputData: {
        to: '0x5008a47004b1cACD0Fd7CE689973F6b0CB345802',
        mpc: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        from: '0x61851ecB1cdFa72698d5724DFFCA5138B3304ef3',
        tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
        depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
        signature:
          '0xb2ad592d75b9f98b9eaad20f9fc8212093d1d62b0de64a8ddca1fc7fb30db7263a67d5a3e5470a409647b295acdc8914b5e31b350f2310f131d8ae413933fe5e1b',
        depositFromList: ['0x53bebc978f5afc70ac3bffad7bbd88a351123723'],
        transactionHash: '0xd32c58f4395da71e934cc801892f03db611ef1c4c5c5bf474a0d1b40c2f1ccd7',
      },
      createdAt: '2025-05-23T11:26:51.842Z',
      updatedAt: '2025-05-23T11:26:51.842Z',
      depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
    },
    {
      tradeId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
      action: 'Deposited',
      txId: '0x3db51fb77c88db96c52ceaedfec9f449d017d60deca560610a39d63edfde89e6',
      blockNumber: 5407495,
      timestamp: 1747999526,
      inputData: {
        depositTxId: '0x3db51fb77c88db96c52ceaedfec9f449d017d60deca560610a39d63edfde89e6',
        depositVault: '0x8827171FcB8739a8E5efCe10b42004Cb96c269b5',
      },
      createdAt: '2025-05-23T11:25:27.223Z',
      updatedAt: '2025-05-23T11:25:27.223Z',
      depositId: '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f',
    },
  ],
}

export const MOCK_DEPOSIT_ID = '0xda7e1e0a06c0f6db2eaee17ee9223cc38f2317d8f3d421378901b1f8cba08c1f'

export const MOCK_VAULT_HISTORY: IVaultDeposit[] = [MOCK_VAULT_DETAIL as any]

export const MOCK_VAULTS: Vault[] = [MOCK_VAULT_DETAIL as any]
